import { ITranslations } from 'types/common';
import { ProductTransFields } from './types';
import en from 'translations/en/product.json';
import pl from 'translations/pl/product.json';
import sl from 'translations/sl/product.json';

export const productTranslations: ITranslations<ProductTransFields> = {
  name: 'product',
  en,
  pl,
  sl,
};
